<!-- ========== PAGE HERO ========== -->
<section class="ds-page-hero">
  <div class="ds-orb ds-orb--soft ds-page-hero__orb-1"></div>
  <div class="ds-orb ds-orb--cobalt ds-page-hero__orb-2"></div>
  <div class="container ds-page-hero__inner">
    <span class="ds-pill">Açık Rıza</span>
    <h1>Açık Rıza Metni</h1>
    <p class="ds-lead">
      Açık rızanıza dayanarak gerçekleştirilen kişisel veri işleme
      faaliyetlerinin kapsamı.
    </p>
  </div>
</section>

<!-- ds-legal => scroll-reveal gözlemcisinden muaftır (app.component.ts) -->
<section class="ds-section ds-legal">
  <div class="container">
    <div class="ds-legal__doc">

      <p class="ds-legal__meta">
        Sürüm {{ version }} · Son güncelleme:
        <time [attr.datetime]="lastUpdated.iso">{{ lastUpdated.label }}</time>
      </p>

      <h2>Web Sitesi Açık Rıza Metni</h2>
      <p>
        6698 sayılı Kişisel Verilerin Korunması Kanunu
        (<strong>"KVKK"</strong>) uyarınca,
        <strong>Keyo Dijital Çözümler A.Ş.</strong>
        (<strong>"Şirket"</strong> veya <strong>"Keyo AI"</strong>) olarak,
        <a href="https://keyo-ai.com">keyo-ai.com</a> internet sitesini ziyaretiniz
        ve hizmetlerimizi kullanmanız sırasında elde edilen kişisel verilerinizin
        işlenmesine ilişkin olarak
        <a routerLink="/aydinlatma-metni">Aydınlatma Metni</a> ile
        bilgilendirilmiş bulunmaktasınız.
      </p>

      <div class="ds-legal__callout">
        <p>
          <strong>Önemli:</strong> Kişisel verilerinizin büyük bölümü, Kanun'un
          5. maddesinde sayılan ve açık rıza gerektirmeyen hukuki sebeplere
          dayanılarak işlenmektedir. İşbu metin yalnızca
          <strong>açık rızaya dayalı</strong> işleme faaliyetlerini kapsar ve
          bu rızanın alındığı hâllerde geçerlidir. Açık rıza vermemeniz,
          hizmetlerimizden yararlanmanıza engel değildir.
        </p>
      </div>

      <h2>Rızanın Kapsamı</h2>
      <p>
        Tarafıma sunulan Aydınlatma Metni kapsamında, kişisel verilerimin
        aşağıdaki amaçlarla işlenmesine açık rıza veriyorum:
      </p>
      <ul>
        <li>İnternet sitesi ziyaretçi trafiğinin analiz edilmesi,</li>
        <li>Kullanıcı deneyiminin iyileştirilmesi,</li>
        <li>Tanıtım ve pazarlama faaliyetlerinin yürütülmesi (çerezler yoluyla profil oluşturulması dâhil),</li>
        <li>Tarafıma ticari elektronik ileti gönderilmesi,</li>
        <li>İstatistiki raporlamaların yapılması.</li>
      </ul>

      <h2>Aktarıma İlişkin Rıza</h2>
      <p>
        Yukarıda belirtilen amaçlarla sınırlı olmak üzere kişisel verilerimin;
        Keyo Dijital Çözümler A.Ş., iş ortakları, hizmet sağlayıcıları ve
        yetkili kamu kurum ve kuruluşları ile paylaşılabileceğini kabul ediyorum.
      </p>
      <p>
        Ayrıca, Kanun'un 9. maddesi uyarınca, hakkında yeterlilik kararı
        bulunmayan veya uygun güvencelerin sağlanamadığı hâllerde kişisel
        verilerimin <strong>yurt dışında bulunan sunuculara ve hizmet
        sağlayıcılara aktarılmasına</strong> açık rıza veriyorum.
      </p>

      <h2>Rızanın Geri Alınması</h2>
      <p>
        Açık rızanızı dilediğiniz zaman geri alabilirsiniz. Geri alma talebiniz,
        talebin tarafımıza ulaştığı andan itibaren geçerli olur ve geri alma
        öncesinde gerçekleştirilmiş işleme faaliyetlerinin hukuka uygunluğunu
        etkilemez.
      </p>
      <p>
        Ticari elektronik iletileri, iletilerin içindeki ret bağlantısı ya da
        İleti Yönetim Sistemi (İYS) üzerinden dilediğiniz zaman
        durdurabilirsiniz.
      </p>
      <p>
        Rızanızı geri almak veya bu metne ilişkin sorularınızı iletmek için
        aşağıdaki kanalları kullanabilirsiniz:
      </p>
      <app-veri-sorumlusu></app-veri-sorumlusu>

      <app-legal-links></app-legal-links>
    </div>
  </div>
</section>
